// @flow
import React from 'react'
import classnames from 'classnames'

type PropsT = {
  className?: string,
  fill?: string,
  stroke?: string
}

const IconInfo = ({ className, stroke, fill, ...rest }: PropsT) => (
  <svg
    className={classnames('Icon IconInfo', className)}
    viewBox='0 0 32 32'
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <path fillRule="evenodd" d="M16,4 C22.6171429,4 28,9.38285714 28,16 C28,22.6171429 22.6171429,28 16,28 C9.38285714,28 4,22.6171429 4,16 C4,9.38285714 9.38285714,4 16,4 Z M16,6 C10.4677333,6 6,10.4677333 6,16 C6,21.5322667 10.4677333,26 16,26 C21.5322667,26 26,21.5322667 26,16 C26,10.4677333 21.5322667,6 16,6 Z M15.983733,14.0001557 C15.4325302,14.0088776 14.9925791,14.461234 15.0000982,15.0108081 L15.0000982,21.9893507 C14.9963483,22.2560315 15.1000871,22.5127334 15.2875671,22.7034111 C15.4750471,22.8928287 15.7325097,23 16,23 C16.2674903,23 16.5236858,22.8928287 16.711185,22.7034111 C16.8999129,22.5127462 17.0036517,22.2560507 16.9999018,21.9893507 L16.9999018,15.0108081 C17.0036517,14.7416358 16.8974139,14.4811726 16.706184,14.291771 C16.514954,14.1011061 16.2537222,13.9951822 15.9837682,14.0001684 L15.983733,14.0001557 Z M17.5,11.5 C17.5,13.5 14.5,13.5 14.5,11.5 C14.5,9.5 17.5,9.5 17.5,11.5"/>
  </svg>
)

export default IconInfo
